import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from './AuthContext'; 
import './Navbar.css';

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const { user, logout } = useAuth();

  return (
    
    <nav className="navbar">
      
      <div className="burger" onClick={() => setOpen(!open)}>☰</div>
      <ul className={`menu ${open ? 'open' : ''}`}>
        <li><Link to="/" onClick={() => setOpen(false)}>Главная</Link></li>
        <li><Link to="/about">О нас</Link></li>
        <li><Link to="/cart" onClick={() => setOpen(false)}>Корзина</Link></li>
        {user ? (
          <>
            <li>
              <span onClick={() => { logout(); setOpen(false); }} className="menu-link logout-link">
                Выйти
              </span>
            </li>

            {user.is_staff && (
              <li><Link to="/admin-panel" onClick={() => setOpen(false)}>Изменить товары</Link></li>
            )}
          </>
        ) : null}
      </ul>


      
    </nav>
  );
};

export default Navbar;
